// CustomCol.tsx
import React from 'react';
import {
  Col as BootstrapCol,
  ColProps,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';

interface CustomColProps extends ColProps {
  width?: string; // Define a largura em percentual
  helpText?: string;
  borderRadius?: string;
  name?: string;
  'data-testid'?: boolean | string;
  helpTextWidth?: string | number;
}

const CustomCol: React.FC<CustomColProps> = ({
  children,
  width,
  style,
  helpText,
  name,
  'data-testid': dataTestId,
  helpTextWidth,
  ...props
}) => {
  const testId =
    typeof dataTestId === 'string'
      ? dataTestId
      : dataTestId
        ? `col-${name || props.id || 'layout'}`
        : undefined;
  return (
    <BootstrapCol
      style={{ flex: `0 0 ${width}`, maxWidth: width, ...style }}
      data-testid={testId}
      {...props}
    >
      {helpText ? (
        <OverlayTrigger
          placement="top-start"
          overlay={
            <Tooltip
              id={`tooltip-${props.id || 'custom-col'}`}
              style={{
                width:
                  typeof helpTextWidth === 'number'
                    ? `${helpTextWidth}px`
                    : helpTextWidth,
                maxWidth:
                  typeof helpTextWidth === 'number'
                    ? `${helpTextWidth}px`
                    : helpTextWidth,
                textAlign: 'left',
              }}
            >
              {helpText}
            </Tooltip>
          }
        >
          <div style={{ display: 'inline-block', width: '100%' }}>
            {children}
          </div>
        </OverlayTrigger>
      ) : (
        children
      )}
    </BootstrapCol>
  );
};

export default CustomCol;
